import React from 'react';
import Hero from '../modern-components/sections/Hero';
import ProductsSection from '../modern-components/sections/ProductsSection';
import BrandsSection from '../modern-components/sections/BrandsSection';
import ValueProposition from '../modern-components/sections/ValueProposition';
import Features from '../modern-components/sections/Features';
import ProductCategories from '../modern-components/sections/ProductCategories';
import Testimonials from '../modern-components/sections/Testimonials';
import CTA from '../modern-components/sections/CTA';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <ProductsSection />
      <BrandsSection />
      <ValueProposition />
      <Features />
      <ProductCategories />
      <Testimonials />
      <CTA />
    </div>
  );
};

export default Home;
